/* Ivitapure — Crealyte PDP: galleriet i köpdelen (snippets/ivitapure-cpdp-gallery).
   Under 900 px är listan en vågrät karusell: räknaren och prickarna följer
   scrollpositionen, och en prick scrollar till sin bild. På desktop är listan ett
   rutnät och skriptet gör ingenting synligt — utom när galleriet har klassen
   is-carousel (inställningen "Galleriet på desktop"), då är det karusell överallt.
   Idempotent: varje galleri får en flagga på elementet. Filen kan laddas flera
   gånger; dokumentlyssnarna binds bara en gång. Temaredigeraren: omladdad sektion
   kopplas in igen, och ett markerat block scrollas fram i karusellen. */
(function () {
  'use strict';

  var ROOT = '[data-cpdp-mgal]';

  if (window.__cpdpGallery) {
    window.__cpdpGallery.scan(document);
    return;
  }

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function init(root) {
    if (!root || root.__cpdpMgal) return;
    root.__cpdpMgal = true;

    var list = root.querySelector('[data-cpdp-mgal-list]');
    var items = list ? list.querySelectorAll('[data-cpdp-mgal-item]') : [];
    var dots = root.querySelectorAll('[data-cpdp-mgal-dot]');
    var thumbs = root.querySelector('.cpdp-gallery-thumbs');
    var current = root.querySelector('[data-cpdp-mgal-current]');
    var mq = window.matchMedia ? window.matchMedia('(max-width: 899.98px)') : null;
    var active = -1;
    var raf = 0;
    var lockTo = -1;      /* mål för en prickstyrd scroll: prickarna hoppar inte förbi bilderna emellan */
    var lockTimer = 0;

    root.classList.add('is-ready');
    if (!list || items.length < 2) return;

    function isCarousel() {
      /* is-carousel = karusell även på desktop (inställningen "Galleriet på desktop") */
      if (root.classList.contains('is-carousel')) return true;
      return mq ? mq.matches : window.innerWidth < 900;
    }

    function indexFromScroll() {
      if (!isCarousel()) return 0;
      var x = list.scrollLeft;
      var max = list.scrollWidth - list.clientWidth;
      if (max <= 2) return 0;
      if (x >= max - 2) return items.length - 1;
      var base = items[0].offsetLeft;
      var best = 0;
      var bestD = Infinity;
      for (var i = 0; i < items.length; i++) {
        var d = Math.abs(items[i].offsetLeft - base - x);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }

    /* Miniatyrraden rullar i sidled på mobil, där alla rutor inte får plats på
       skärmbredden. Håll den aktiva rutan synlig när man sveper i bilden.
       scrollIntoView går inte att använda: den skulle dra även sidans lodräta
       scroll och rycka bort bilden man just tittar på. Därför räknas läget ut
       mot radens egen ram och sätts med scrollLeft. Ryms hela raden — desktop —
       gör funktionen ingenting. */
    function keepThumbInView() {
      if (!thumbs) return;
      var slack = thumbs.scrollWidth - thumbs.clientWidth;
      if (slack <= 2) return;
      var on = thumbs.querySelector('.is-active');
      if (!on) return;
      var tr = thumbs.getBoundingClientRect();
      var br = on.getBoundingClientRect();
      var mal = thumbs.scrollLeft + (br.left - tr.left) - (tr.width - br.width) / 2;
      mal = Math.max(0, Math.min(mal, slack));
      if (Math.abs(mal - thumbs.scrollLeft) < 1) return;
      if (thumbs.scrollTo) thumbs.scrollTo({ left: mal, behavior: reducedMotion() ? 'auto' : 'smooth' });
      else thumbs.scrollLeft = mal;
    }

    function setActive(i) {
      if (i === active) return;
      active = i;
      /* Både prickarna och miniatyrraden har data-cpdp-mgal-dot, så listan innehåller
         två knappar per bild. Läs bildnumret ur attributet, inte ur loopindexet. */
      for (var j = 0; j < dots.length; j++) {
        var on = (parseInt(dots[j].getAttribute('data-cpdp-mgal-dot'), 10) || 0) === i;
        dots[j].classList.toggle('is-active', on);
        if (on) dots[j].setAttribute('aria-current', 'true');
        else dots[j].removeAttribute('aria-current');
      }
      keepThumbInView();
      if (current) current.textContent = String(i + 1);
      root.classList.toggle('is-first', i === 0);
      root.classList.toggle('is-last', i === items.length - 1);
    }

    function goTo(i, instant) {
      if (!items[i] || !isCarousel()) return;
      var left = items[i].offsetLeft - items[0].offsetLeft;
      var behavior = (instant || reducedMotion()) ? 'auto' : 'smooth';
      window.clearTimeout(lockTimer);
      if (behavior === 'smooth') {
        lockTo = i;
        lockTimer = window.setTimeout(function () {
          lockTo = -1;
          setActive(indexFromScroll());
        }, 900);
      } else {
        lockTo = -1;
      }
      try {
        list.scrollTo({ left: left, behavior: behavior });
      } catch (e) {
        list.scrollLeft = left;
      }
    }

    function onScroll() {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = 0;
        var i = indexFromScroll();
        if (lockTo >= 0) {
          if (i !== lockTo) return;
          lockTo = -1;
          window.clearTimeout(lockTimer);
        }
        setActive(i);
      });
    }

    /* Karusellen går att scrolla med piltangenterna när den har fokus.
       I rutnätet finns inget att scrolla, så där blir listan inget tabbstopp. */
    function sync() {
      if (isCarousel()) list.setAttribute('tabindex', '0');
      else list.removeAttribute('tabindex');
      active = -1;
      setActive(indexFromScroll());
    }

    list.addEventListener('scroll', onScroll, { passive: true });

    /* En klickstyrd mjuk scroll låser räknaren tills den nått fram (lockTo). Rör
       användaren karusellen själv under tiden hamnar räknaren fel i upp till en
       sekund, så låset släpps så fort någon tar över. */
    /* Pilarna: ett steg i taget från den bild som visas just nu. */
    var prevKnapp = root.querySelector('[data-cpdp-mgal-prev]');
    var nextKnapp = root.querySelector('[data-cpdp-mgal-next]');
    function stega(steg) {
      var nu = active < 0 ? indexFromScroll() : active;
      var mal = Math.min(items.length - 1, Math.max(0, nu + steg));
      if (mal === nu) return;
      setActive(mal);
      goTo(mal, false);
    }
    if (prevKnapp) prevKnapp.addEventListener('click', function () { stega(-1); });
    if (nextKnapp) nextKnapp.addEventListener('click', function () { stega(1); });

    function slappLas() {
      if (lockTo < 0) return;
      lockTo = -1;
      window.clearTimeout(lockTimer);
    }
    ['wheel', 'touchstart', 'pointerdown'].forEach(function (evt) {
      list.addEventListener(evt, slappLas, { passive: true });
    });

    /* Home och End till första respektive sista bilden, som i vilken karusell som helst. */
    list.addEventListener('keydown', function (e) {
      slappLas();
      if (!isCarousel()) return;
      var last = items.length - 1;
      if (e.key === 'Home') { e.preventDefault(); setActive(0); goTo(0, false); }
      else if (e.key === 'End') { e.preventDefault(); setActive(last); goTo(last, false); }
    });

    Array.prototype.forEach.call(dots, function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-cpdp-mgal-dot'), 10) || 0;
        setActive(i);
        goTo(i, false);
      });
    });

    if (mq) {
      if (mq.addEventListener) mq.addEventListener('change', sync);
      else if (mq.addListener) mq.addListener(sync);
    }

    root.__cpdpMgalGo = function (el, instant) {
      var i = Array.prototype.indexOf.call(items, el);
      if (i < 0) return;
      goTo(i, instant);
      setActive(i);
    };
    root.__cpdpMgalDestroy = function () {
      if (mq) {
        if (mq.removeEventListener) mq.removeEventListener('change', sync);
        else if (mq.removeListener) mq.removeListener(sync);
      }
      list.removeEventListener('scroll', onScroll);
      if (raf) window.cancelAnimationFrame(raf);
      window.clearTimeout(lockTimer);
    };

    sync();
  }

  function scan(scope) {
    var r = scope || document;
    if (r.matches && r.matches(ROOT)) init(r);
    if (r.querySelectorAll) Array.prototype.forEach.call(r.querySelectorAll(ROOT), init);
  }

  window.__cpdpGallery = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  document.addEventListener('shopify:section:unload', function (e) {
    var t = e.target;
    if (!t || !t.querySelectorAll) return;
    Array.prototype.forEach.call(t.querySelectorAll(ROOT), function (root) {
      if (root.__cpdpMgalDestroy) root.__cpdpMgalDestroy();
    });
  });

  /* Markerat Galleribild-block i temaredigeraren: visa det i karusellen */
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var item = t.closest('[data-cpdp-mgal-item]');
    var root = item && item.closest(ROOT);
    if (!root) return;
    if (!root.__cpdpMgal) init(root);
    if (root.__cpdpMgalGo) root.__cpdpMgalGo(item, true);
  });
})();
